<template>
  <div id="airtel">
<v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
         {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{'providers._clt_airtel_'|translate}} : {{this.users.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        right
        append-icon="search"
       :label="$t('general._search_')"
        single-line
        hide-details
      ></v-text-field>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
            <download-excel
	class   = "btn btn-default"
	:data   = "users"
	:fields = "json_fields"
  type    = "csv"
	name    = "airtel.csv">
  <button type="button" class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}}
</button> 
</download-excel>

        <v-data-table
          :headers="headers"
          :items="users"
          class="elevation-0"
          :pagination.sync="pagination"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-avatar size="36px">
                <img :src="props.item.imageUrl" alt="" />
              </v-avatar>
            </td>
            <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.accessCode }}</td>
            <td class="text-xs-left">{{ props.item.role }}</td>
            <td class="text-xs-left">{{ props.item.city }}</td>
            <td class="text-xs-right">
              <v-btn flat icon color="grey">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import NameCard from "@/components/widgets/card/NameCard";
// import ProfileCard from '@/components/widgets/card/ProfileCard';
export default {
  components: {
    NameCard
    // ProfileCard
  },
  data() {
    return {
      search: '',
      loading: true,
            headers: [
          {
            text:this.$t('members._photo_'),
            align: 'left',
            sortable: false,
            value: 'imageUrl'
          },
          { text:this.$t('members._fullname_'), value: 'lastName' },
          { text:this.$t('members._phone_'), value: 'phone' },
          { text:this.$t('members._access_code_') , value: 'accessCode' },
          { text:this.$t('members._rule_'), value: 'role' },
          { text:this.$t('providers._city_') , value: 'city' },
          { text:this.$t('members._delete_') , value: 'Edit' }
        ],

                   json_fields: {
        'Nom et Prenom': 'lastName',
        'Telephone': 'phone',
        "Code d'accees":"accessCode",
         'Role': 'role',
          'Commune': 'city'
              },
      pagination: {
        sortBy: "lastName",
        rowsPerPage: "100"
      }
    };
  },
  computed: {
    users () {
      let members = this.$store.getters.airtel;
      this.loading = false;
      return members;
    }
  },
  fetchTotal() {
    this.users.forEach((item, index) => {
      var fullName = item.firstName + " " + item.lastName;
      var ref = db.collection("Census");
      var query = ref
        .where("createdBy", "==", fullName)
        .orderBy("createdDate", "desc");
      query.get().then(querySnapshot => {
        if (!querySnapshot.empty) {
          var today = new Date().toString();
          today = today.substring(0, 15);
          this.loading = false;
          var data = querySnapshot.docs.map(function(documentSnapshot) {
            return documentSnapshot.data();
          });
          this.$set(this.users[index], "totalEntries", data.length);
          var j = 0;
          for (var i = 0; i < data.length; i++) {
            if (data[i].createdDate) {
              var current = data[i].createdDate.toString();
              current = current.substring(0, 15);
              //  alert(`employee ${current}`)
              if (current === today) {
                j += 1;
              }
            }
          }
          this.$set(users[index], "dailyEntries", j);
        }
      });
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/providers/Airtel.vue